import cx from 'classnames';
import { Children, Fragment, ReactNode } from 'react';
import css from './VrContainer.module.scss';

interface IVrContainerProps {
  className?: string;
  children: ReactNode;
}

export const VrContainer = ({ children, className }: IVrContainerProps) => (
  <div className={cx(css.container, className)}>
    {Children.map(children, (child, index) => (
      <Fragment key={index}>
        {!!child && <div aria-hidden className={css.vr} />}
        {child}
      </Fragment>
    ))}
  </div>
);
